<template>
  <div>
    <h1>New MediaObject</h1>

    <div
      v-if="isLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ error }}</span>
    </div>

    <MediaObjectForm
      :handle-submit="onSendForm"
      :values="item"
      :errors="violations" />

    <router-link
      :to="{ name: 'MediaObjectList' }"
      class="btn btn-default">Back to list</router-link>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import { mapActions } from 'vuex';
import MediaObjectForm from './Form';

const { mapFields } = createHelpers({
    getterType: 'mediaobject/create/getField',
    mutationType: 'mediaobject/create/updateField',
});

export default {
  components: {
    MediaObjectForm,
  },

  data () {
    return {
      item: {},
    };
  },

  computed: {
    ...mapFields([
      'error',
      'isLoading',
      'created',
      'violations',
    ]),
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function(created) {
      if (!created) {
        return;
      }

      this.$router.push({ name: 'MediaObjectUpdate', params: { id: created['@id'] } });
    }
  },

  methods: {
    ...mapActions('mediaobject/create', [
      'create',
    ]),

    onSendForm () {
      this.create(this.item);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/mediaobject/Create.vue